import * as fromDatatype from '../datatype-library/index';

export interface bl_inv_bin_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  qty: fromDatatype.NumericDatatypeInterface;
  container_qty: fromDatatype.NumericDatatypeInterface;
  container_measure: fromDatatype.NumericDatatypeInterface;
  container_uom: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  mrp_bin_type: fromDatatype.VarcharDatatypeInterface;
  reservation_status: fromDatatype.VarcharDatatypeInterface;
  reservation_qty: fromDatatype.NumericDatatypeInterface;
  container_width: fromDatatype.NumericDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  original_container_measure: fromDatatype.NumericDatatypeInterface;
}

export class bl_inv_bin_line_RowClass implements bl_inv_bin_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  qty: fromDatatype.NumericDatatypeInterface;
  container_qty: fromDatatype.NumericDatatypeInterface;
  container_measure: fromDatatype.NumericDatatypeInterface;
  container_uom: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  mrp_bin_type: fromDatatype.VarcharDatatypeInterface;
  reservation_status: fromDatatype.VarcharDatatypeInterface;
  reservation_qty: fromDatatype.NumericDatatypeInterface;
  container_width: fromDatatype.NumericDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  original_container_measure: fromDatatype.NumericDatatypeInterface;
}
